<template>
  <!-- 得意先情報 -->
  <div id="AppMasterMaintenanceCustomerInfo">
    <!-- 上部余白 -->
    <div style="height: 20px;" />
    <div style="margin-left: 50px; margin-right: 50px;">
      <div class="columns">
        <div class="column is-one-third">
          <b-field class="file">
            <b-upload v-model="addfile" v-on:input="changeAddfile">
              <a class="button is-primary">
                <b-icon icon="upload"></b-icon>
                <span>得意先情報アップロード(追加)</span>
              </a>
            </b-upload>
          </b-field>
        </div>
        <div class="column is-one-third">
          <b-field class="file">
            <b-upload v-model="uploadfile" v-on:input="changeUploadfile">
              <a class="button is-primary">
                <b-icon icon="repeat"></b-icon>
                <span>得意先情報アップロード(更新)</span>
              </a>
            </b-upload>
          </b-field>
        </div>
        <div class="column is-one-third">
          <b-field class="file">
            <b-button
              expanded
              class="button is-primary has-text-centered"
              icon-left="download"
              native-type="button"
              v-on:click="doDownload"
            >得意先ファイルダウンロード</b-button>
          </b-field>
        </div>
      </div>
    </div>
    <!-- 下部余白 -->
    <div style="height: 10px;" />
  </div>
</template>

<script>
export default {
  name: "AppMasterMaintenanceCustomerInfo",
  methods: {
    doDownload: function() {
      var excuteApi = this.downloadCustomerFilePOST;
      var errorCallBack = this.downloadFileError;
      // WebAPI Call
      this.downloadApiCall(excuteApi, errorCallBack);
    },
    downloadCustomerFilePOST: function(client) {
      return client.apis.apiMaster.downloadCustomerFilePOST({});
    },
    downloadFileError: function(result) {
      this.showErrorMessage(result);
    },
    changeAddfile: function() {
      var excuteApi = this.uploadAddCustomerFilePOST;
      var successCallBack = this.addSuccess;
      var errorCallBack = this.addError;
      // WebAPI Call
      this.uploadApiCall(excuteApi, successCallBack, errorCallBack);
    },
    changeUploadfile: function() {
      var excuteApi = this.uploadUpdateCustomerFilePOST;
      var successCallBack = this.uploadSuccess;
      var errorCallBack = this.uploadError;
      // WebAPI Call
      this.uploadApiCall(excuteApi, successCallBack, errorCallBack);
    },
    changeDeletefile: function() {
      var excuteApi = this.uploadDeleteCustomerFilePOST;
      var successCallBack = this.deleteSuccess;
      var errorCallBack = this.deleteError;
      // WebAPI Call
      this.uploadApiCall(excuteApi, successCallBack, errorCallBack);
    },
    uploadAddCustomerFilePOST: function(client) {
      console.log("addfile =" + this.addfile);
      return client.apis.apiMaster.uploadAddCustomerFilePOST({
        upfile: this.addfile
      });
    },
    uploadUpdateCustomerFilePOST: function(client) {
      console.log("uploadfile =" + this.uploadfile);
      return client.apis.apiMaster.uploadUpdateCustomerFilePOST({
        upfile: this.uploadfile
      });
    },
    uploadDeleteCustomerFilePOST: function(client) {
      console.log("deletefile =" + this.deletefile);
      return client.apis.apiMaster.uploadDeleteCustomerFilePOST({
        upfile: this.deletefile
      });
    },
    addSuccess: function(result) {
      // WebAPI応答内容を画面に設定
      this.showSuccess(result);
      this.addfile = null;
    },
    uploadSuccess: function(result) {
      // WebAPI応答内容を画面に設定
      this.showSuccess(result);
      this.uploadfile = null;
    },
    deleteSuccess: function(result) {
      // WebAPI応答内容を画面に設定
      this.showSuccess(result);
      this.deletefile = null;
    },
    addError: function(result) {
      this.showErrorMessage(result);
      this.addfile = null;
    },
    uploadError: function(result) {
      this.showErrorMessage(result);
      this.uploadfile = null;
    },
    deleteError: function(result) {
      this.showErrorMessage(result);
      this.deletefile = null;
    }
  },
  data() {
    return {
      addfile: null,
      uploadfile: null,
      deletefile: null
    };
  },
  filters: {},
  components: {}
};
</script>


// WEBPACK FOOTER //
// src/components/AppMasterMaintenanceCustomerInfo.vue